import { UserType } from '@src/types/main';

import { apiSlice } from '../api/api-slice';

type LoginRequest = {
  email: string;
  password: string;
};

type LoginResponse = {
  userId: string;
  token: string;
  registered: boolean;
  User: UserType;
};

type InviteRequest = {
  loginUrl: string;
  email: string;
  role: string;
};

type RegisterRequest = {
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  invitationId: string;
  host: string;
};

type ForgotPasswordRequest = {
  email: string;
  host: string;
};

type UpdatePasswordRequest = {
  oldPassword: string;
  newPassword: string;
  email: string;
};

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/loginEmailPassword',
        method: 'POST',
        body: credentials,
      }),
    }),
    invite: builder.mutation<{}, InviteRequest>({
      query: (args) => ({
        url: '/invitations',
        method: 'POST',
        body: { ...args },
      }),
    }),
    register: builder.mutation<LoginResponse, RegisterRequest>({
      query: (args) => ({
        url: '/auth/registerEmailPassword',
        method: 'POST',
        body: {
          username: args.username,
          password: args.password,
          firstName: args.firstName,
          lastName: args.lastName,
        },
        params: { invitationId: args.invitationId, host: args.host },
      }),
    }),
    forgotPassword: builder.mutation<{}, ForgotPasswordRequest>({
      query: (args) => ({
        url: '/auth/forgotPassword',
        method: 'POST',
        body: { email: args.email, host: args.host },
      }),
    }),
    updatePassword: builder.mutation<{}, UpdatePasswordRequest>({
      query: (args) => ({
        url: '/auth/updatePassword',
        method: 'POST',
        body: {
          oldPassword: args.oldPassword,
          newPassword: args.newPassword,
          email: args.email,
        },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useInviteMutation,
  useRegisterMutation,
  useForgotPasswordMutation,
  useUpdatePasswordMutation,
} = authApiSlice;
